import styled from 'foundations-theming/utils';
import { Fragment, useContext, useState } from 'react';
import { PANEL_SHADOW_COLOR } from 'HubStyleTokens/theme';
import { InboundDbListSegStrategy } from 'customer-data-filters-ui/public/strategies';
import { SegmentationFilters } from 'customer-data-filters-ui/public/components';
import CanvasTopOffsetContext from 'automation-ui-enrollment/context/CanvasTopOffsetContext';
import { SIDE_PANEL_DATA_PANEL_WIDTH, SIDE_PANEL_WIDTH } from 'automation-ui-core/constants/ui';
import ErrorBoundary from 'automation-ui-core/errors/ErrorBoundary';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/* SegmentationFilters has inner padding around its filter viewer, but many of our generic components
(ex: action cards) have built-in padding which leads to too much white space. So, control white space on our end */
const RemovedPadding = styled.div.withConfig({
  displayName: "StyledSegmentationFilters__RemovedPadding",
  componentId: "euyaam-0"
})(["", ""], ({
  hasMounted
}) =>
// initial loading spinner state doesn't have excess padding
hasMounted && `margin: -16px;`);
const SegmentationFiltersEditorContainer = styled.div.withConfig({
  displayName: "StyledSegmentationFilters__SegmentationFiltersEditorContainer",
  componentId: "euyaam-1"
})(["background:", ";border-left:1px solid ", ";border-right:1px solid ", ";box-shadow:3px 0 8px 0 ", ";left:", "px;position:fixed;width:", "px;", " &:empty{display:none;}"], ({
  theme
}) => theme.color['do-not-use-olaf'], ({
  theme
}) => theme.color['do-not-use-battleship'], ({
  theme
}) => theme.color['do-not-use-battleship'], PANEL_SHADOW_COLOR, SIDE_PANEL_WIDTH, SIDE_PANEL_DATA_PANEL_WIDTH, ({
  topOffset
}) => `height: calc(100% - ${topOffset}px);
  top: ${topOffset}px;`);
const StyledSegmentationFilters = ({
  baseFilterFamily,
  bannerComponents,
  isReadOnly,
  editButtonsState,
  showDoneButton,
  hideEditCancelDiscardButton,
  uiMessages,
  value,
  translationPrefix,
  openInEditMode,
  skipEmptyFiltersState,
  isEmbedded = false,
  useCustomEditorContainer = true,
  onEditModeChange = () => {},
  onFiltersEditorPanelOpenChange = () => {},
  onChange = () => {},
  strategy = InboundDbListSegStrategy,
  layout = 'embedded',
  WrapperComponent = Fragment,
  onClosePanel
}) => {
  const [hasMounted, setHasMounted] = useState(false);
  const [editorContainer, setEditorContainer] = useState(null);
  const topOffset = useContext(CanvasTopOffsetContext);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "StyledSegmentationFilters",
    renderError: () => /*#__PURE__*/_jsx(UIErrorMessage, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.filters.multiErrorBoundary.title"
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.filters.multiErrorBoundary.description"
      })
    }),
    children: /*#__PURE__*/_jsx(WrapperComponent, {
      children: /*#__PURE__*/_jsxs(RemovedPadding, {
        hasMounted: hasMounted,
        children: [/*#__PURE__*/_jsx(SegmentationFilters, {
          closePanel: onClosePanel,
          baseFilterFamily: baseFilterFamily,
          bannerComponents: bannerComponents,
          isReadOnly: isReadOnly,
          showDoneButton: showDoneButton,
          hideEditCancelDiscardButton: hideEditCancelDiscardButton,
          onEditModeChange: onEditModeChange,
          onEditPanelOpenChange: onFiltersEditorPanelOpenChange,
          uiMessages: uiMessages
          // todo add `originalValue`
          // @ts-expect-error FIXME
          ,
          value: value || {
            filterBranchType: 'OR',
            filterBranchOperator: 'OR',
            filters: [],
            filterBranches: []
          },
          strategy: strategy,
          layout: layout,
          onViewerRender: () => !hasMounted && setHasMounted(true),
          editButtonsState: editButtonsState,
          translationPrefix: translationPrefix
          // been running into tons of UI issues if filters go over virtualization threshhold
          // https://hubspot.slack.com/archives/CA3JB5WLT/p1695935532831759
          ,
          disableVirtualization: true,
          openInEditMode: openInEditMode,
          skipEmptyFiltersState: skipEmptyFiltersState
          // @ts-expect-error FIXME
          ,
          onChange: onChange,
          editorDOMContainer: useCustomEditorContainer && editorContainer ? editorContainer : undefined
        }), /*#__PURE__*/_jsx(SegmentationFiltersEditorContainer, {
          ref: setEditorContainer,
          topOffset: !isEmbedded ? topOffset : 0
        })]
      })
    })
  });
};
export default StyledSegmentationFilters;